import { render } from "./WindowParam.vue?vue&type=template&id=00b3b566&scoped=true"
import script from "./WindowParam.vue?vue&type=script&lang=js"
export * from "./WindowParam.vue?vue&type=script&lang=js"

import "./WindowParam.vue?vue&type=style&index=0&id=00b3b566&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3b566"]])

export default __exports__